import { render, staticRenderFns } from "./NavHeaderMenu.vue?vue&type=template&id=4f72a23e&scoped=true&"
import script from "./NavHeaderMenu.vue?vue&type=script&lang=js&"
export * from "./NavHeaderMenu.vue?vue&type=script&lang=js&"
import style0 from "./NavHeaderMenu.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NavHeaderMenu.vue?vue&type=style&index=1&id=4f72a23e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f72a23e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
